import { PropsWithChildren } from 'react';
import TowerMenu from '../../TowerMenu/TowerMenu';
import TowerLayout from '../../TowerLayout/TowerLayout';
import AppDrawer from '../../components/AppDrawer/AppDrawer';
import BreakingPointsWrapper from '../../TowerLayout/BreakingPointsWrapper';
import { ErrorBoundary } from '../../components/common/ErrorBoundary';

export interface BaseSitePageProps {
    selectedItem: string;
    onSelectedItemChange: (id: string) => void;
}

export default function BaseSitePage({
    children,
    selectedItem,
    onSelectedItemChange
}: PropsWithChildren<BaseSitePageProps>) {
    return (
        <div className="relative flex flex-row h-screen w-screen overflow-hidden">
            <div className="h-full z-[10000] absolute">
                <TowerMenu selectedItem={selectedItem} onSelectedItemChange={onSelectedItemChange} />
            </div>
            <div className="w-screen absolute z-[4000]">
                <TowerLayout selectedItem={selectedItem} />
            </div>
            <AppDrawer />
            <BreakingPointsWrapper>
                <ErrorBoundary resetKeys={[selectedItem]}>{children}</ErrorBoundary>
            </BreakingPointsWrapper>
        </div>
    );
}
